// extracted by mini-css-extract-plugin
export default {"container":"accountResources_container__o0irU","row":"accountResources_row__fzk32","item":"accountResources_item__+AHmN"};